<template>
  <div>
    <v-card class="mb-4">
      <v-card-title>
        {{ title }}
      </v-card-title>

      <apexchart type="heatmap"
                 v-if="!loading"
                 :options="chartOptions"
                 :series="series">
      </apexchart>

    </v-card>
  </div>
</template>
<script>

import { v4 as uuid } from 'uuid';

export default {
  props: {
    loading: {
      type: Boolean,
      required: false,
    },
    metrics: {
      type: Array,
      required: true,
    },
    palette: {
      type: String,
      default: 'palette1',
    },
    period: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    xAxisTitle: {
      type: String,
      required: false,
    }
  },
  data() {
    return {}
  },
  computed: {
    categories() {
      return this.metrics.map(m => {
        return moment().startOf('week').add(m[this.period], 'day').format('ddd');
      });
    },
    series() {
      return [
        {
          name: 'Shares',
          data: this.metrics.map(m => m.shared_links),
        },
        {
          name: 'Hits',
          data: this.metrics.map(m => m.shared_link_hits),
        },
        {
          name: 'Emails sent',
          data: this.metrics.map(m => m.emails_sent),
        },
        {
          name: 'Emails opened',
          data: this.metrics.map(m => m.emails_opened),
        },
        {
          name: 'Emails clicked',
          data: this.metrics.map(m => m.emails_clicked),
        },
      ]
        .reverse();
    },
    chartOptions() {
      return {
        chart: {
          height: 'auto',
          id: uuid(),
          type: 'heatmap',
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          padding: {
            right: 20,
          }
        },
        theme: {
          palette: this.palette,
        },
        xaxis: {
          type: 'category',
          categories: this.categories,
          title: {
            text: this.xAxisTitle,
          }
        },
      };
    },
  }
}
</script>
